// extracted by mini-css-extract-plugin
module.exports = {"spinningIcon":"SpinningIcon_spinningIcon__3pmlN","loader":"SpinningIcon_loader__1NZCL","load2":"SpinningIcon_load2__1VDy2"};